<template>
  <div class="valid-main">
    <div class="left-section" :style="leftSectStyling">
      {{!title ? '-' : title}}
    </div>
    <div class="right-section" :style="rightSectStyling">
      {{!value ? '-' : value}}
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    components: {
    },
		computed : {
			leftSectStyling : function()  {
				return {
					
					backgroundColor : !(this.value) ? 'gray' :  (this.valid) ? 'lightgreen' : 'indianred',
					color: (this.valid) ? '' : 'white'
				}
			},
			rightSectStyling : function () {
				return {
					color: !(this.value) ? 'gray' : (this.valid) ? 'green' : 'indianred'
				}
			}
		},
    props: {
      title: { type: String, default: '' },
      value: { type: String, default: '' },
      valid: { type: Boolean, default: false },
    },
    mounted() {
    },
    methods: {
    },
    watch: {
    },
  }
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.valid-main {
  width: 100%;
  height: 20px;
  display: flex;
  margin-top: 8px;

  > * {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    padding: 5px;
    height: 100%;
  }

  > .left-section {
    min-width : 137px;
    max-width : 137px;
    margin-right: 5px;
  }

  > .right-section {
    width: fit-content;
    font-weight: bold;
  }
}
</style>